import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useTheme } from '../../contexts/ThemeContext';
import SiteLogo from '../../assets/logos/SiteLogo';
import Button from '../Button';
import { SiteNav } from '../Nav';

const Header = ({ mini }) => {
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const renderNavActions = () => (
    <>
      <button
          type="button"
          className="header__theme-toggle"
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={toggleTheme}
        >
          <FontAwesomeIcon icon={theme === 'dark' ? 'fa-solid fa-moon' : 'fa-regular fa-sun'} />
          {/* <FontAwesomeIcon icon='circle-half-stroke' /> */}
        </button>
      {!mini && (
        <>
          <div className='header__links-wrapper'>
            <Button
              variant="ghost"
              href="https://www.linkedin.com/in/itsmedrew/"
              className="header__link-button"
            >
              LinkedIn
            </Button>
            <Button
              variant="ghost"
              href="https://www.itsmedrew.com/resume/drew-roberts_resume.pdf"
              className="header__link-button"
            >
              Resume
            </Button>
          </div>
        </>
      )}
    </>
  );

  return (
    <header className={classnames('header', { mini, 'header--menu-open': menuOpen })}>
      {menuOpen && (
        <div
          className="header__mobile-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Site menu"
          onClick={closeMenu}
        >
          <div
            className="header__mobile-overlay-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="header__mobile-overlay-actions">{renderNavActions()}</div>
          </div>
        </div>
      )}

      {mini && (
        <Link to="/" className="header__back" aria-label="Back to home">
          <FontAwesomeIcon icon="close" />
        </Link>
      )}

      <Link to="/" className="header__logo">
        <SiteLogo autoPlayIntro={!mini} key={mini ? 'header-mini' : 'header-main'} />
      </Link>

      {!mini && <SiteNav className="header__site-nav" />}

      <div className="header__nav">
        <button
          type="button"
          className={classnames('header__menu-toggle', { 'is-open': menuOpen })}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span className="header__menu-toggle-bar" aria-hidden />
          <span className="header__menu-toggle-bar" aria-hidden />
          <span className="header__menu-toggle-bar" aria-hidden />
        </button>

        <div className="header__nav-desktop">{renderNavActions()}</div>
      </div>
    </header>
  );
};

export default Header;
